import React from "react";
import tutorial1 from "../../assets/images/games-image.jpg";
import tutorial2 from "../../assets/images/games-image.jpg";
import tutorial3 from "../../assets/images/games-image.jpg";
import tutorial4 from "../../assets/images/games-image.jpg";
import Main from "../../components/layout/Main";

function GuidelineTutorials() {
  return (
    <Main>
      <section>
        <div className="guideline-main-div">
          {/* Heading Section */}
          <div className="guideline-heading-div">
            <h1>Gaming Tutorials & Guides</h1>
            <p>
              Level up your gaming journey with step-by-step guides on gameplay, 
              streaming, tournaments, and community rules.
            </p>
          </div>

          {/* Categories Section */}
          <div className="guideline-categories">
            <div className="guideline-card">
              <div className="guideline-icon">
                <img src={tutorial1} alt="Getting Started" />
              </div>
              <h3>Getting Started</h3>
              <p>Learn how to create your gamer profile and join matches.</p>
            </div>

            <div className="guideline-card">
              <div className="guideline-icon">
                <img src={tutorial2} alt="Gameplay" />
              </div>
              <h3>Gameplay Tips</h3>
              <p>Pro strategies, character builds, and winning tactics.</p>
            </div>

            <div className="guideline-card">
              <div className="guideline-icon">
                <img src={tutorial3} alt="Streaming" />
              </div>
              <h3>Streaming Setup</h3>
              <p>Step-by-step guide to set up Twitch / YouTube live streams.</p>
            </div>

            <div className="guideline-card">
              <div className="guideline-icon">
                <img src={tutorial4} alt="Community" />
              </div>
              <h3>Community Rules</h3>
              <p>Fair play, anti-cheat, and respectful behavior guidelines.</p>
            </div>
          </div>

          {/* Featured Tutorials */}
          <div className="featured-tutorials">
            <h2>Featured Tutorials</h2>
            <div className="featured-list">
              <div className="featured-item">
                <h3>How to join your first online tournament?</h3>
                <span>Updated: May 12, 2025</span>
              </div>
              <div className="featured-item">
                <h3>Best OBS settings for smooth game streaming</h3>
                <span>Updated: May 10, 2025</span>
              </div>
              <div className="featured-item">
                <h3>Top 5 tips to improve your reaction speed</h3>
                <span>Updated: Apr 30, 2025</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Main>
  );
}

export default GuidelineTutorials;
